import React from "react";
import { Modal } from "react-bootstrap";

export default function ErrorPopUp(props) {
return (
    <Modal
      show={props.show}
      onHide={props.onClose}
      centered
      backdrop="static" // Prevent closing on overlay click
      keyboard={false}
      contentClassName="p-3"
    >
      <Modal.Header className="flex-column p-0 border-0">
        <p className="custom-title mb-0">{props.heading}</p>
      </Modal.Header>
      <Modal.Body className="mt-4 mb-4 p-0">
        <p className="text-center m-0">
            {props.text}
        </p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center border-0 p-0">
        <div className="m-0 ms-2">
          <button onClick={props.onClose} className="cancel-btn m-0"
            style={{padding:"6px 30px"}}
          >
            Close
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}